import React, {useEffect} from 'react'
import loadable from '@wix/yoshi-flow-editor/loadable'
import {ModalsProps} from './interfaces'
import {OrderSummary} from './order-summary'
import {NativeModal} from './constants'
import {TicketsDownload} from './tickets-download'
import {ConfirmRsvp} from './confirm-rsvp'

const SeatingPlanModal = loadable(() => import(/* webpackChunkName: "seating-plan-modal" */ './seating-plan'))

export const Modals = ({modalType, plan, blockScroll, unblockScroll}: ModalsProps) => {
  useEffect(() => {
    if (modalType) {
      blockScroll?.()
    } else {
      unblockScroll?.()
    }
    return () => {
      unblockScroll?.()
    }
  }, [modalType])

  switch (modalType) {
    case NativeModal.ORDER_SUMMARY:
      return <OrderSummary />
    case NativeModal.TICKETS_DOWNLOAD:
      return <TicketsDownload />
    case NativeModal.SEATING_PLAN:
      if (!plan) {
        return null
      }

      return <SeatingPlanModal />
    case NativeModal.CONFIRM_RSVP:
      return <ConfirmRsvp />
    default:
      return null
  }
}
